import { isValid } from 'date-fns';

export class ServiceUtils {
  /**
   *
   * @param opt
   * @returns
   */
  public static toTime(opt?: Date | string): number {
    if (!opt) {
      return 0;
    }
    const v = opt instanceof Date ? opt : new Date(opt);
    return isValid(v) ? Math.floor(v?.getTime() / 1000) : 0;
  }
}
